import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { apiClient } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = React.useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const m = hash.match(/session_id=([^&]+)/);
    const sid = m ? decodeURIComponent(m[1]) : null;
    if (!sid) {
      navigate("/", { replace: true });
      return;
    }
    (async () => {
      try {
        await apiClient.post(
          "/auth/google-login",
          {},
          { headers: { "X-Session-ID": sid } }
        );
        // Claim any pending referral code that was captured pre-login
        try {
          const pending = localStorage.getItem("pending_referral_code");
          if (pending) {
            try {
              await apiClient.post("/referral/claim", { code: pending });
            } catch (e) {
              // Non-fatal — referral may already be claimed or expired
              console.warn("Referral claim failed:", e?.response?.data || e?.message);
            }
            localStorage.removeItem("pending_referral_code");
          }
        } catch (e) {
          console.warn("Could not read pending referral code:", e);
        }
        await refresh();
        // Clean the URL fragment
        window.history.replaceState(null, "", "/dashboard");
        navigate("/dashboard", { replace: true });
      } catch (e) {
        console.error("Auth callback failed", e);
        navigate("/?auth_error=1", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="brut-lg p-8 flex items-center gap-3" data-testid="auth-callback-loading">
        <span className="spinner" />
        <span className="text-sm">Signing you in…</span>
      </div>
    </div>
  );
}
